const t = "test", p = (e) => {
  var s;
  return (s = e == null ? void 0 : e.replace) == null ? void 0 : s.call(e, /([^\/])$/, "$1/");
}, r = (e) => e == null ? void 0 : e.replace(/^([^\/])/, "/$1"), c = /* @__PURE__ */ (() => {
  const e = {
    test: "https://platform-components-external-test.adyen.com/platform-components-external/api/",
    live: "https://platform-components-external-live.adyen.com/platform-components-external/api/"
  };
  return (s) => e[s ?? t] || e[t];
})();
export {
  t as FALLBACK_ENV,
  p as normalizeLoadingContext,
  r as normalizeUrl,
  c as resolveEnvironment
};
